export default function () {
	return {
		accept_cookies: false,
		policy_modal: false,
		policy_preferences_modal: false,
	}
}
